const userDetails = [
  // Existing user data
  {
    username: "Amit Sharma",
    phoneNumber: "9876543210",
    email: "amitsharma@example.com",
    password: "Amit@1234",
  },
  {
    username: "Priya Verma",
    phoneNumber: "8765432109",
    email: "priyaverma@example.com",
    password: "Priya@5678",
  },
  {
    username: "Rajesh Kumar",
    phoneNumber: "7654321098",
    email: "rajeshkumar@example.com",
    password: "Rajesh@9101",
  },
  {
    username: "Sneha Patel",
    phoneNumber: "6543210987",
    email: "snehapatel@example.com",
    password: "Sneha@2345",
  },
  {
    username: "Vikram Singh",
    phoneNumber: "5432109876",
    email: "vikramsingh@example.com",
    password: "Vikram@6789",
  },

  // New admin accounts (no phone numbers)
  {
    username: "Admin John",
    phoneNumber: null,
    email: "adminjohn@example.com",
    password: "Admin@2021",
  },
  {
    username: "Admin Sara",
    phoneNumber: null,
    email: "adminsara@example.com",
    password: "Admin@2345",
  },
  {
    username: "Admin Paul",
    phoneNumber: null,
    email: "adminpaul@example.com",
    password: "Admin@5678",
  },
  {
    username: "Admin Nancy",
    phoneNumber: null,
    email: "adminnancy@example.com",
    password: "Admin@6789",
  },

  // New volunteer accounts
  {
    username: "Volunteer Ashok",
    phoneNumber: "9871000001",
    email: "ashokvolunteer@example.com",
    password: "Ashok@1111",
  },
  {
    username: "Volunteer Neeta",
    phoneNumber: "9871000002",
    email: "neetavolunteer@example.com",
    password: "Neeta@2222",
  },
  {
    username: "Volunteer Ravi",
    phoneNumber: "9871000003",
    email: "ravivolunteer@example.com",
    password: "Ravi@3333",
  },
  {
    username: "Volunteer Poonam",
    phoneNumber: "9871000004",
    email: "poonamvolunteer@example.com",
    password: "Poonam@4444",
  },
  {
    username: "Volunteer Suman",
    phoneNumber: "9871000005",
    email: "sumanvolunteer@example.com",
    password: "Suman@5555",
  },
  {
    username: "Volunteer Ramesh",
    phoneNumber: "9871000006",
    email: "rameshvolunteer@example.com",
    password: "Ramesh@6666",
  },
  {
    username: "Volunteer Anu",
    phoneNumber: "9871000007",
    email: "anuvolunteer@example.com",
    password: "Anu@7777",
  },
  {
    username: "Volunteer Amitabh",
    phoneNumber: "9871000008",
    email: "amitabhvolunteer@example.com",
    password: "Amitabh@8888",
  },
  {
    username: "Volunteer Meena",
    phoneNumber: "9871000009",
    email: "meenavolunteer@example.com",
    password: "Meena@9999",
  },
  {
    username: "Volunteer Mahesh",
    phoneNumber: "9871000010",
    email: "maheshvolunteer@example.com",
    password: "Mahesh@1010",
  },
];

export default userDetails;
